module.exports = __webpack_public_path__ + "img/cup-disabled.f7d32d2c.svg";